import { UseMutationOptions } from "@tanstack/react-query";
import { useAuthMutation } from "@rentablo/api";
import {
  BookingsApiListAndSearchAllBookingsRequest,
  InvestmentsApiListAndSearchAllInvestmentsRequest,
  buildBookingsApi,
  buildInvestmentsApi,
} from "@rentablo/api/apiv1";

type Options = UseMutationOptions<Blob, AxiosApiError, unknown>;

// The generated client sends list filters as repeated keys (type=a&type=b),
// the form the API reads. With responseType blob the response is the file,
// not the list type the client declares.
export const useDownloadBookingsCsv = (
  params: BookingsApiListAndSearchAllBookingsRequest,
  options?: Options
) =>
  useAuthMutation(async (token) => {
    const { data } = await buildBookingsApi(token).listAndSearchAllBookings(
      { ...params, format: "csv" },
      { responseType: "blob" }
    );
    return data as unknown as Blob;
  }, options);

export const useDownloadInvestmentsCsv = (
  {
    displayCurrency,
    ...params
  }: InvestmentsApiListAndSearchAllInvestmentsRequest & {
    displayCurrency?: string;
  },
  options?: Options
) =>
  useAuthMutation(async (token) => {
    const { data } = await buildInvestmentsApi(
      token
    ).listAndSearchAllInvestments(
      { ...params, format: "csv" },
      // Missing from the API spec for this endpoint, but the export uses it.
      { responseType: "blob", params: { displayCurrency } }
    );
    return data as unknown as Blob;
  }, options);
